<div *ngIf="isLoggingOut" class="logout-overlay">
  <div class="logout-spinner"></div>
  <p class="logout-text">Logging out...</p>
</div>

<!-- Header bar: keep all three columns on one row on phones. The decorative
     "Powered by WhatsLoan" block hides below 768px so the menu + logo and the
     user menu can share the row instead of stacking. -->
<div class="row sticky-header" *ngIf="!isLoggingOut">
  <div class="col-8 col-md-6">
    <button mat-button class="border-none-important bg-white-important commonButton" (click)="sidenav.toggle()">
      <i><img src="../../assets/svg/baseline_menu_black_18dp.png" class="header-menu-icon"></i>
    </button>
    <img class="logo h-44px p-5px" id="logoId" src="../../assets/ubi_logo.jpg" alt="logo">
  </div>
  <div class="d-none d-md-flex col-md-4 header-powered-by">
    <img class="logo h-40px w-180px" src="../assets/whatsloan.png" alt="WhatsLoan">
    <p class="font-size-small">Powered by</p>
  </div>
  <div class="col-4 col-md-2">
    <button mat-button class="btn-transparent-custom commonButton header-user-btn" [matMenuTriggerFor]="menu">
      <span class="mr-8px">{{userName}}</span>
      <i><img src="../../assets/svg/baseline_expand_more_black_18dp.png"></i>
    </button>
    <mat-menu #menu="matMenu" [overlapTrigger]="false">
      <div class="mb-1rem">
        <button mat-menu-item class="userposition ml-3rem mb-neg4rem">
          <span><b>{{userName}}</b></span>
        </button>
        <button mat-menu-item>
          <i><img class="h-25px m-neg5px pr-10px" src="../../assets/svg/user-profile-icon.svg"></i>
          <span class="vertical-align-text-top">Level: {{level}}</span>
        </button>
      </div>
      <button mat-menu-item [routerLink]="['setting']">
        <i><img class="h-25px m-neg5px pr-10px" src="../../assets/svg/password.svg"></i>
        <span>Change Password</span>
      </button>
      <button mat-menu-item (click)="adminLogout()">
        <i><img class="h-25px m-neg5px pr-10px" src="../../assets/svg/baseline_logout_black_24dp.png"></i>
        <span>Logout</span>
      </button>
    </mat-menu>
  </div>
</div>

<mat-sidenav-container>
  <mat-sidenav id="laasSideNav" [mode]="sideNav.mode" [opened]="sideNav.isOpened" #sidenav>
    <div class="menu-container" *ngFor="let menuItem of navList; let i=index">
      <p class="row" (click)="toggleSubmenu(menuItem)" [ngStyle]="menuItem.isSelected ? {'background-color':'#03569C'} : ''" (click)="changeColor(i)">
        <mat-icon *ngIf="menuItem.icon"><img src="{{menuItem.icon}}"></mat-icon>
        <span class="mb-15px-important">{{menuItem.name}}</span>
        <span class="empty-space"></span>
        <mat-icon *ngIf="menuItem.submenu"></mat-icon>
        <i class="position-absolute-important right-20px text-center-important" *ngIf="menuItem.submenu">
          <img src="../../assets/svg/white/baseline_expand_more_white_24dp.png">
        </i>
      </p>
      <ul *ngIf="menuItem.isSubmenuVisible">
        <li *ngFor="let submenu of menuItem.submenu; let j=index" [routerLink]="submenu.link" [ngStyle]="submenu.isSubMenuSelected ? {'background-color':'#03569C'} : ''" (click)="changeColorSubMenu(i, j)">{{submenu.name}}</li>
      </ul>
    </div>
  </mat-sidenav>
  <router-outlet></router-outlet>
</mat-sidenav-container>

